import React from 'react';
import { Box, Typography } from '@mui/material';
import { mvkgTokens } from '../../theme/mvkgTokens';
import Kicker from './Kicker';

/** Small stacked stat (value over kicker label) for 2–4 column stat grids. */
export default function MiniStat({ value, label, align = 'left', sx = {} }) {
  return (
    <Box sx={{ textAlign: align, ...sx }}>
      <Typography
        sx={{
          fontFamily: mvkgTokens.font.display,
          fontWeight: 700,
          fontSize: '1.4rem',
          lineHeight: 1.1,
          letterSpacing: '-0.01em',
        }}
      >
        {value}
      </Typography>
      <Kicker sx={{ mt: 0.5 }}>{label}</Kicker>
    </Box>
  );
}
